'use client';
import styles from './apply.module.css';
import { useSession } from 'next-auth/react';
import { useRouter } from 'next/navigation';
import useModal from '@/components/modal/use-modal';
import Modal from '@/components/modal/modal';
import Auth from '@/components/auth/auth';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@awesome.me/kit-012d1b9af0/icons/classic/regular';

type ApplyProps = {
	prop: [string, string] | (() => void);
	disable?: boolean;
};

export default function Apply({ prop, disable = false }: ApplyProps) {
	const { data: session } = useSession();
	const { isOpen, onClose, onOpen } = useModal();

	const router = useRouter();

	function applyHandler() {
		if (!session?.user) {
			onOpen('login-modal');
		} else {
			if (typeof prop === 'function') {
				prop();
			} else {
				router.push(`/trial/${prop[0]}/apply/${prop[1]}`);
			}
		}
	}
	return (
		<>
			<button
				className={`${styles.apply} ${disable && styles.disabled}`}
				onClick={applyHandler}
				disabled={disable}
			>
				{disable ? (
					<>
						<FontAwesomeIcon icon={faCheck} color='#fff' size='lg' /> applied
					</>
				) : (
					'apply'
				)}
			</button>
			<Modal
				isOpen={isOpen('login-modal')}
				onClose={() => onClose('login-modal')}
				auto
			>
				<Auth onClose={() => onClose('login-modal')} />
			</Modal>
		</>
	);
}
